module.exports = __webpack_public_path__ + "static/circleImg-80bb82b71f9fc85d480ef8a5e52e552c.png";